import restApi from "./rest.service";

const basePath = `${process.env.REACT_APP_API_BASE_URL}/store`;

const pageNumber = 1;
const pageSize = 10000;

const fetchCatalogs = async (ids) => {
	try {

		const queryString = ids.map((id) => `line_ids[]=${id}`).join("&");

		const url = `${basePath}/catalog?${queryString}&page=${pageNumber}&page_size=${pageSize}`;

		const response = await restApi.get(url);
		if (response.data?.catalogs) {
			return response.data.catalogs;
		}

		return null;
	} catch (error) {
		console.error("catalogService.fetchCatalogs", "Error get lines", error);
		return null;
	}
};

export const catalogService = {
	fetchCatalogs,
};
